import { FC } from 'react'
import { Spinner } from '@chakra-ui/react'

export const LoadingNewAnswer: FC = () => {
  return <Spinner />
}
